import { render, staticRenderFns } from "./UsdtTransactionList.vue?vue&type=template&id=5a7199d3&scoped=true&"
import script from "./UsdtTransactionList.vue?vue&type=script&lang=ts&"
export * from "./UsdtTransactionList.vue?vue&type=script&lang=ts&"
import style0 from "./UsdtTransactionList.vue?vue&type=style&index=0&id=5a7199d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7199d3",
  null
  
)

export default component.exports